import _regeneratorRuntime from "babel-runtime/regenerator";

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import Measure from "./Measure";

var VideoPreview = function (_React$Component) {
  _inherits(VideoPreview, _React$Component);

  function VideoPreview() {
    var _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, VideoPreview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.updateVideoSource = function () {
      var _this$props = _this.props,
          source = _this$props.source,
          stream = _this$props.stream;
      _this.srcVideo.src = source;

      if (_this.streamVideo.srcObject !== stream) {
        _this.streamVideo.pause();

        _this.streamVideo.srcObject = stream;

        if (stream) {
          _this.playVideo(_this.streamVideo);
        }
      }

      if (_this.srcVideo !== source) {
        _this.srcVideo.pause();

        _this.srcVideo.src = source;

        if (source) {
          _this.playVideo(_this.srcVideo);
        }
      }
    }, _this.playVideo = function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(video) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                video.load();
                _context.next = 4;
                return video.play();

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 6]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  VideoPreview.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _props = this.props,
        source = _props.source,
        stream = _props.stream;
    return nextProps.source !== source || nextProps.stream !== stream;
  };

  VideoPreview.prototype.componentDidMount = function componentDidMount() {
    this.updateVideoSource();
  };

  VideoPreview.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateVideoSource();
  };

  VideoPreview.prototype.render = function render() {
    var _this3 = this;

    var _props2 = this.props,
        source = _props2.source,
        stream = _props2.stream,
        onResize = _props2.onResize,
        onVideoSizeReceived = _props2.onVideoSizeReceived;
    return React.createElement("section", {
      style: {
        width: "100%",
        height: "100%",
        paddingBottom: 60,
        overflow: "hidden"
      }
    }, React.createElement("video", {
      ref: function ref(video) {
        _this3.streamVideo = video;

        if (video) {
          video.addEventListener("loadedmetadata", function (e) {
            var width = this.videoWidth;
            var height = this.videoHeight;
            onVideoSizeReceived && onVideoSizeReceived(width, height);
          }, false);
        }
      },
      playsInline: true,
      muted: true,
      autoPlay: true,
      className: "preview",
      style: {
        display: stream ? "block" : "none"
      }
    }), React.createElement("video", {
      ref: function ref(video) {
        _this3.srcVideo = video;

        if (video) {
          video.addEventListener("loadedmetadata", function (e) {
            var width = this.videoWidth;
            var height = this.videoHeight;
            onVideoSizeReceived && onVideoSizeReceived(width, height);
          }, false);
        }
      },
      controls: true,
      playsInline: true,
      autoPlay: true,
      className: "preview",
      style: {
        display: source ? "block" : "none"
      }
    }), React.createElement(Measure, {
      onSizeChange: onResize
    }));
  };

  return VideoPreview;
}(React.Component);

export { VideoPreview as default };
VideoPreview.propTypes = process.env.NODE_ENV !== "production" ? {
  source: PropTypes.string,
  stream: PropTypes.object,
  onResize: PropTypes.func,
  onVideoSizeReceived: PropTypes.func
} : {};